module.exports = __webpack_public_path__ + "img/sodelco-logo-2x.5453a682.png";